// extracted by mini-css-extract-plugin
module.exports = {"main":"page_main__yqC3L","content":"page_content__6OBz9"};